export interface PaymentServicesFilterType {
  paymentServiceName: string | null;
  priceFrom: number | null;
  priceTo: number | null;
}

export const defaultPaymentServicesFilter = (): PaymentServicesFilterType => ({
  paymentServiceName: null,
  priceFrom: null,
  priceTo: null,
});
